import { render, staticRenderFns } from "./Sugestoes.vue?vue&type=template&id=29467208&scoped=true"
import script from "./Sugestoes.vue?vue&type=script&lang=js"
export * from "./Sugestoes.vue?vue&type=script&lang=js"
import style0 from "./Sugestoes.vue?vue&type=style&index=0&id=29467208&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29467208",
  null
  
)

export default component.exports